import { z } from 'zod';

const schema = z.object({
  colorMode: z.enum(['system', 'light', 'dark']),
  // we use supabase session, not used for now
  session: z
    .object({
      user: z.object({
        id: z.string(),
        email: z.string(),
      }),
    })
    .optional(),
  signedUrls: z.record(
    z.object({ signedUrl: z.string(), expiration: z.number() }),
  ),
  sidebarState: z.boolean(),
  invites: z.object({
    pendingInviteCode: z.string().optional(),
  }),
  //   reminders: z.object({
  //     lastEmailConfirm: z.string().optional(),
  //   }),
  //   languagePrefs: z.object({
  //     appLanguage: z.string(),
  //   }),
  //   onboarding: z.object({
  //     step: z.string(),
  //   }),
});
export type Schema = z.infer<typeof schema>;

export const defaults: Schema = {
  colorMode: 'system',
  session: undefined,
  signedUrls: {},
  sidebarState: true,
  invites: {
    pendingInviteCode: undefined,
  },
};

export function tryParse(rawData: string): Schema | undefined {
  let objData;
  try {
    objData = JSON.parse(rawData);
  } catch (e) {
    console.error('persisted state: failed to parse root state from storage', {
      message: e,
    });
  }
  if (!objData) {
    return undefined;
  }
  const parsed = schema.safeParse(objData);
  if (parsed.success) {
    return objData;
  } else {
    const errors =
      parsed.error?.errors?.map((e) => ({
        code: e.code,
        // @ts-expect-error exists on some types
        expected: e?.expected,
        path: e.path?.join('.'),
      })) || [];
    console.error(`persisted store: data failed validation on read`, {
      errors,
    });
    return undefined;
  }
}

export function tryStringify(value: Schema): string | undefined {
  try {
    schema.parse(value);
    return JSON.stringify(value);
  } catch (e) {
    console.error(`persisted state: failed stringifying root state`, {
      message: e,
    });
    return undefined;
  }
}
